import { TFunction } from "i18next";
import { ReactNode, createElement, Fragment } from "react";

const featureTranslationKeys: Record<string, string> = {
    AiStepPrompt: "Setup.AiFeatureConfiguration.AiStep",
    AiAssistedResponse: "Setup.AiFeatureConfiguration.AiAssistantResponse",
};

export const buildAgentUsageTooltip = (
    t: TFunction,
    usedByFeatures?: string[],
    usedByAgents?: string[],
): ReactNode => {
    const lines: string[] = [];

    if (usedByFeatures && usedByFeatures.length > 0) {
        const translatedFeatures = usedByFeatures
            .map(f => t(featureTranslationKeys[f] ?? f))
            .join(", ");
        lines.push(t("Shared.AgentUsedByFeatures", { features: translatedFeatures }));
    }

    if (usedByAgents && usedByAgents.length > 0) {
        lines.push(t("Shared.AgentUsedByAiAgents", { agents: usedByAgents.join(", ") }));
    }

    if (lines.length <= 1) {

        return lines[0] ?? "";
    }

    return createElement(Fragment, null,
        ...lines.flatMap((line, i) =>
            i > 0 ? [createElement("br", { key: i }), line] : [line]
        )
    );
};
